import fetch from '@/utils/fetch';
import * as types from './mutation_types';
import store from '@/store';
import moment from 'moment';

const showInMap = (data, params) => {
  let events = fetchEvents(data);
  store.commit(`map/list/${types.SET_ITEMS}`, events);
  store.commit(`map/list/${types.SET_ITEM_INFO}`, params);
  store.commit(`map/list/${types.SET_LOADING}`, false);
};

export const fetchEvents = (devices) => {
  if (!devices || devices.length === 0) {
    return [];
  }
  const events = [];
  devices.forEach(device => {
    if (!device) return;
    // Cas 1: Mode tracé (un seul device avec son historique)
    if (device.eventsdata && Array.isArray(device.eventsdata)) {
      device.eventsdata.forEach(event => {
        if (event && event.point_latitude && event.point_longitude) {
          events.push({
            ...event,
            imei: device.imei,
            name: device.name,
            display_name: device.display_name,
            color: device.color
          });
        }
      });
    }
    // Cas 2: Mode normal (dernier événement de chaque device)
    else if (device.latest_event) {
      const event = device.latest_event;
      if (event.point_latitude && event.point_longitude) {
        events.push({
          ...event,
          imei: device.imei,
          name: device.name,
          display_name: device.display_name,
          color: device.color
        });
      }
    }
  });
  return events;
};

export const centerPosition = ({ commit }, { position, zoom, selectItem }) => {
  commit(types.SET_CENTER_MAP, position);
  commit(types.SET_ZOOM_MAP, zoom);
  commit(types.SET_SELECT_ITEM, selectItem);
};

const paramsFilter = (type, data) => {
  const params = [];
  
  if (type == types.SEARCH_GROUP || type == types.SEARCH_GROUP_LAST) {
    params.push(`group_id[eq]=${data}`);
  }
  
  if (type == types.SEARCH_DEVICE_LAST || type == types.SEARCH_DEVICE) {
    params.push(`id[eq]=${data}`);
  }
  
  // Ajouter le paramètre lastevent
  params.push(`lastevent=${type.includes('LAST')}`);
  
  return '?' + params.join('&');
};

export const getMapData = ({ commit }, { type, data, isParamsFilter = true }, page = 'devices') => {
  var params = isParamsFilter ? paramsFilter(type, data) : type;
  
  // Gestion du filtre par date
  if (type == types.SEARCH_DATE) {
    let param = data.lastSearch?.split("&start_date")[0] == undefined ? "?" : data.lastSearch.split("&start_date")[0] + "&";
    params = `${param}start_date=${moment(data.searchDate.startDate).format("YYYY-MM-DD")}&end_date=${moment(data.searchDate.endDate).format("YYYY-MM-DD")}`;
  }
  
  commit(types.SET_LOADING, true);
  return fetch({
    url: `${page}${params}`,
  })
    .then(({ data }) => {
      let items = fetchEvents(data['data']);
      commit(types.SET_LOADING, false);
      commit(types.SET_ITEMS, items);
      commit(types.SET_IS_DEVICE, data['isdevice']);
      commit(types.SET_INFOS_TYPE, data['info']);
      commit(types.SET_ITEM_INFO, params);
      commit(types.SET_SEARCH, "");
      commit(types.SET_MESSAGE, data['message']);
      return data;
    })
    .catch((e) => {
      commit(types.SET_LOADING, false);
      commit(types.SET_ERROR, e.message);
      throw e;
    });
};

export const resetMapData = ({ commit }) => {
  commit(types.RESET);
};

export default showInMap;